<template>
    <div>
        <div v-if="needsTruncation">
            <div v-if="!showFull">
                <!-- disable linting; because we modify whitespace this actually has to be on one line -->
                <!-- eslint-disable-next-line -->
                <div
                    class="attachment-note-container"
                    data-test-role="attachment-note">
                    {{ truncatedContent }}
                </div>
            </div>
            <div v-else>
                <!-- disable linting; because we modify whitespace this actually has to be on one line -->
                <!-- eslint-disable-next-line -->
                <div
                    class="attachment-note-container"
                    data-test-role="attachment-note">
                    {{ note }}
                </div>
            </div>
            <div>
                <pc-button
                    class="px-0"
                    link
                    v-on:click.stop="toggleShowHide">
                    {{ toggleText }}
                </pc-button>
            </div>
        </div>
        <div v-else>
            <!-- disable linting; because we modify whitespace this actually has to be on one line -->
            <!-- eslint-disable-next-line -->
            <div
                class="attachment-note-container"
                data-test-role="attachment-note">
                {{ note }}
            </div>
        </div>
    </div>
</template>

<script>
    import { getTruncatedNoteContent, ATTACHMENT_NOTE_CHAR_LIMIT } from "Util/clientAttachment";

    export default {
        props: {
            note: { type: String, required: false, default: null }
        },
        data() {
            return {
                showFull: false
            };
        },
        computed: {
            needsTruncation() {
                return this.note && this.note.length > ATTACHMENT_NOTE_CHAR_LIMIT;
            },
            truncatedContent() {
                return getTruncatedNoteContent(this.note);
            },
            toggleText() {
                return this.showFull ? "Show less" : "Show more...";
            }
        },
        methods: {
            toggleShowHide() {
                this.showFull = !this.showFull;
            }
        }
    };
</script>
<style lang="scss">
    .attachment-note-container {
        white-space: pre-line;
    }
</style>
